// ----------------------
// AI CREATE VENDOR
// ----------------------
export interface PendingVendor {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  company?: string;
  company_address?: string;
  industry_type?: string;
  gstin?: string;
  status?: string;
}

// ----------------------
// AI DELETE VENDOR
// ----------------------
export interface PendingDeleteVendor {
  awaitingName?: boolean;
}

export const startCreateVendorFlow = (
  setPendingVendor: (data: PendingVendor | null) => void,
  pushAIChat: (msg: string) => void,
  speak: (msg: string) => void
) => {
  setPendingVendor({});
  pushAIChat("What is the vendor's first name?");
  speak("What is the vendor's first name?");
};

export const processPendingVendor = (
  text: string,
  pending: PendingVendor,
  setPendingVendor: (data: PendingVendor | null) => void,
  pushAIChat: (msg: string) => void,
  speak: (msg: string) => void
) => {

  if (!pending.first_name) {
    setPendingVendor({ ...pending, first_name: text });
    pushAIChat("Please provide vendor email.");
    speak("Please provide vendor email.");
    return;
  }

  if (!pending.email) {
    setPendingVendor({ ...pending, email: text });
    pushAIChat("Please provide phone number.");
    speak("Please provide phone number.");
    return;
  }

  if (!pending.phone_number) {
    setPendingVendor({ ...pending, phone_number: text });
    pushAIChat("What is the company name?");
    speak("What is the company name?");
    return;
  }

  if (!pending.company) {
    setPendingVendor({ ...pending, company: text });
    pushAIChat("What is the industry type?");
    speak("What is the industry type?");
    return;
  }

  if (!pending.industry_type) {
    setPendingVendor({ ...pending, industry_type: text });
    pushAIChat("Vendor status? Active or Inactive.");
    speak("Vendor status? Active or Inactive.");
    return;
  }

  if (!pending.status) {
    const finalData = {
      ...pending,
      status: text.toLowerCase(),
    };

    pushAIChat("Creating vendor...");
    speak("Creating vendor.");

    window.dispatchEvent(
      new CustomEvent("ai-create-vendor", {
        detail: finalData,
      })
    );

    setPendingVendor(null);
  }
};

export const startDeleteVendorFlow = (
  setPendingDelete: (data: PendingDeleteVendor | null) => void,
  pushAIChat: (msg: string) => void,
  speak: (msg: string) => void
) => {
  setPendingDelete({ awaitingName: true });
  pushAIChat("Please tell me the vendor name to delete.");
  speak("Please tell me the vendor name to delete.");
};

export const processPendingDeleteVendor = (
  text: string,
  pending: PendingDeleteVendor,
  setPendingDelete: (data: PendingDeleteVendor | null) => void,
  pushAIChat: (msg: string) => void,
  speak: (msg: string) => void
) => {
  if (!pending.awaitingName) return;

  pushAIChat(`Deleting vendor ${text}...`);
  speak(`Deleting vendor ${text}.`);

  window.dispatchEvent(
    new CustomEvent("ai-delete-vendor", {
      detail: { name: text },
    })
  );

  setPendingDelete(null);
};
